import { type ParagraphType } from '@blocksuite/affine-model';
import { defineBlockSchema, type SchemaToModel } from '@blocksuite/store';

export const PiqueParagraphBlockSchema = defineBlockSchema({
  flavour: 'affine:paragraph',
  props: internal => ({
    type: 'text' as ParagraphType,
    text: internal.Text(),
    timestamps: internal.Text(),
    originalText: internal.Text(),
    augmentedText: internal.Text(),
    isAugmented: false,
  }),
  metadata: {
    version: 1,
    role: 'content',
    parent: [
      'affine:note',
      'affine:database',
      'affine:paragraph',
      'affine:list',
      'affine:edgeless-text',
    ],
  },
});

export type PiqueParagraphBlockModel = SchemaToModel<
  typeof PiqueParagraphBlockSchema
>;

